import wixWindow from 'wix-window'
let siteutl = "https://checkup.co.il"
$w.onReady(function () {
 
$w("#repeater1").onItemReady(($item, itemData, index) => {
    let copylink = $item("#copylink")
let contact = $item("#contact")

 copylink.onClick( (event) => {
wixWindow.copyToClipboard(siteutl+itemData.postPageUrl)
      });
    
contact.onClick( (event) => {
  $w("#menuContainer1").open()

      });
  });


$w("#repeater3").onItemReady(($item, itemData, index) => {
    let button = $item("#button19")

	
if(itemData.showbooking){
    button.expand()
}

      });

$w("#repeater5").onItemReady( ($item, itemData, index) => {
  const num = $item("#num");
  const box = $item("#box269");
  
  const item = $item("#box270");

num.text = (index+1).toString()
  

  item.onClick( (event) => {

if ( box.collapsed) {
	  box.expand()
}else{box.collapse()

}


} );

 


});

});
